import axios from "axios";
import config from "config";

const host = typeof BROWSER_ENV === "undefined" ? config.get( "client.host" ) : "";
export default axios.create({
    baseURL: host,
    withCredentials: true
});